<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-6">{{ new Date().getFullYear() }} © KoueLab.</div>
        <div class="col-sm-6">
          <div class="text-sm-end d-none d-sm-block">
            Design & Development by
            <a target="_blank" href="https://kouelab.com">KoueLab</a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
